export interface ReorderFiguresRequest {
    /** 附图ID列表，按期望的顺序排列 */
    figure_ids: string[];
}

export interface ReorderFiguresResponse {
    /** 调整的附图数量 */
    reordered_count: number;
}

export const ReorderFiguresApi = Symbol.for('ReorderFiguresApi');

export interface ReorderFiguresApi {
    reorderFigures(
        task_id: string,
        data: ReorderFiguresRequest,
        options?: { single: AbortSignal }
    ): Promise<ReorderFiguresResponse>;
}
